import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';

export default function SidebarNewBadge({ colors, label }) {
  return (
    <View
      style={{
        backgroundColor: colors.accent_color_primary,
        paddingHorizontal: 5,
        paddingVertical: 1,
        borderRadius: 4,
        marginRight: 2,
        alignSelf: 'center',
      }}
    >
      <Text
        weight="extraBold"
        style={{
          color: colors.accent_text_color,
          fontSize: 9,
          letterSpacing: 0.6,
          lineHeight: 12,
        }}
      >
        {label}
      </Text>
    </View>
  );
}
